import React, { Component } from 'react'
import Aux from '../../hoc/Aux/Aux'
import Burger from '../../components/Burger/Burger'
import BuildControls from '../../components/Burger/BuildControls/BuildControls'
import Modal from '../../components/UI/Modal/Modal'
import OrderSummary from '../../components/Burger/OrderSummary/OrderSummary'
import Spinner from '../../components/UI/Spinner/Spinner'
import withErrorHandler from '../../hoc/withErrorHandler/withErrorHandler'
import {connect } from 'react-redux'
import axios from '../../../src/axios-orders' 
import * as actions from '../../store/actions/index'


const INGREDIENT_PRICE = {
    salad: 5,
    cheese: 10,
    meat: 20,
    bacon: 30
}

export class BurgerBuilder extends Component {
  
    state = {
         purchasing: false,
    
    }

    componentDidMount () {
      this.props.initIngredients()
    }

    addIngredientHandler = (type) => {
      const oldCount = this.props.ingredients[type]
      const updatedCount = oldCount + 1
      const updatedIngredients = {
          ...this.props.ingredients
      }
      updatedIngredients[type] = updatedCount
      const oldPrice = this.props.price
      const addedPrice = INGREDIENT_PRICE[type]
      const newPrice = oldPrice + addedPrice
      this.setState({ingredients:updatedIngredients, totalPrice:newPrice})
      this.updatePurchaseState(updatedIngredients)

    }
    removeIngredientHandler = (type) => {
        const oldCount = this.props.ingredients[type]
        if(oldCount <= 0){
            return
        }
        const updatedCount = oldCount - 1
        const updatedIngredients = {
            ...this.props.ingredients
        }
        updatedIngredients[type] = updatedCount
        const oldPrice = this.props.price
        const removedPrice = INGREDIENT_PRICE[type]
        const newPrice = oldPrice - removedPrice
        this.setState({ingredients:updatedIngredients, totalPrice:newPrice})
        this.updatePurchaseState(updatedIngredients)
  
    }
    updatePurchaseState = (ingredients) => {
      const sum = Object.keys(ingredients)
      .map(igKey => {
          return ingredients[igKey]
      })
      .reduce((sum, el) => {
          return sum + el
      })
      return sum > 0
    }

    purchaseHandler  = () => {
        if(this.props.isAuthenticated) {
            this.setState({purchasing: true})
        } else {
            this.props.onSetAuthRedirectPath('/checkout')
            this.props.history.push('/auth')
        }
    }

    purchaseContinuedHandler = () => { 

        this.props.onInitPurchase()
        this.props.history.push('/checkout')
        
    }

    purhaseCancelledHandler = () => {
     this.setState({purchasing:false})
    }

   
    render () {
     const disabledInfo = {
         ...this.props.ingredients
     }
     for(let key in disabledInfo) {
         disabledInfo[key] = disabledInfo[key] <= 0
     }

     let orderSummary = this.props.ingredients ? <OrderSummary 
         ingredients={this.props.ingredients}
         price={this.props.price}
         purchaseCancelled={this.purhaseCancelledHandler}
         purchaseContinued={this.purchaseContinuedHandler}
      /> : <Spinner />

    
      let burger =   this.props.error ? <p>Ingredients can't be loaded!</p>: <Spinner />
       
      if(this.props.ingredients) {
         burger =  
         (
        <Aux>
            <Burger ingredients={this.props.ingredients}/>
            <BuildControls 
                        price={this.props.price}
                        disabled={disabledInfo}
                        ingredientAdded={ this.props.onIngredientAdded}
                        ingredientRemoved={this.props.onIngredientRemoved}
                        purchaseAble = {this.updatePurchaseState(this.props.ingredients)}
                        ordered={this.purchaseHandler}   
                        isAuth={this.props.isAuthenticated}
                    />

            </Aux>

         )
      }

        return (
            <Aux>
                   <Modal show={this.state.purchasing} modalClosed={this.purhaseCancelledHandler} >
                      {orderSummary}
                     </Modal>
                      {burger}
                 
            </Aux>
        )
    }
}


const mapStateToProps = state => {
   return {
    ingredients: state.burgerReducer.ingredients,
    price: state.burgerReducer.totalPrice,
    error: state.burgerReducer.error,
    isAuthenticated: state.authReducer.token !== null
   }
}


const mapDispatchToProps = dispatch => {
  return {
    initIngredients: () => dispatch(actions.initIngredients()),
    onIngredientAdded: (ingName) => dispatch(actions.addIngredient(ingName)),
    onIngredientRemoved: (ingName) => dispatch(actions.removeIngredient(ingName)),
    onInitPurchase: () => dispatch(actions.purchaseInit()),
    onSetAuthRedirectPath: (path) => dispatch(actions.setAuthRedirectPath(path))

  }
}



export default  connect(mapStateToProps, mapDispatchToProps)(withErrorHandler(BurgerBuilder, axios))


// WEBPACK FOOTER //
// ./src/containers/BurgerBuilder/BurgerBuilder.js